<template>
  <el-checkbox v-bind="$attrs" class="rt-checkbox"> <slot /> </el-checkbox>
</template>

<script>
export default {
  name: 'RtCheckbox'
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-checkbox {
  @{deep} {
    .el-checkbox__inner {
      width: 16px;
      height: 16px;
      &::after {
        height: 8px;
        left: 5px;
      }
    }
    .el-checkbox__label {
      color: #143e81;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtCheckbox.vue?549660e8